export const primaryBGColor: string = '#091c29';
